<template>
  <div class="full-screen">
    <div v-if="dataUnavailable== true" style="align-items: center;,justify-content: center;display:flex;font-size:bold;">
      <h5>Data Unavailable</h5>
    </div>
    <div v-else>
    <div class="">
        <q-tooltip >{{campaignName }}</q-tooltip>
      <div class="asin-dropdown col-5 row q-px-sm q-ml-sm">
        <q-btn-dropdown class="drop-down col-6 q-mr-sm q-my-lg" :label="campaignName1">
          <q-list dense>
            <q-item clickable v-for="item in products" :key="item" v-close-popup @click="setGraph(item)">
              <q-item-section>
                <q-item-label>{{ item }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
      </div>
    </div>
    <div class="row q-mb-md q-ml-md">
      <div class="graph col">
        <h5>Quantity Sold Vs Date</h5>
        <apexchart type=line height="350"  :options="chartOptions1" :series="series1" />
      </div>
      <div class="graph col">
        <h5>Total Sales in Past 3 months</h5>
        <apexchart type="pie" height="450" :options="chartOptions2" :series="series2"></apexchart>
      </div>
    </div>
    <div class="row q-mb-md q-ml-md">
      <div class="graph col">
        <h5>Sell Through Rate Vs Date</h5>
        <apexchart type="area" height="350" :options="chartOptions3" :series="series3"></apexchart>
      </div>
      <div class="graph barchart col">
        <h5>Actual Vs Predicted Sales</h5>
        <apexchart type=bar height="350" width="1000" :options="chartOptions4" :series="series4" style="width:auto"/>
      </div>
    </div>
  </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      array: [],
      products: [],
      actual: [],
      predicted: [],
      date: [],
      campaignName: '',
      campaignName1: '',
      dataUnavailable: false,
      area: [],
      line: [],
      series1: [{
        name: '',
        data: []
      }],
      chartOptions1: {
        chart: {
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width:2
        },

      },
      series2: [],
       chartOptions2: {
                legend: {
                    position: 'bottom',
                    height:120
                },
            },
      series3: [{
        name: "",
        data: []
      }],
      chartOptions3: {
        chart: {
          type: 'area',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: [],

        legend: {
          horizontalAlign: 'left'
        }
      },
      chartOptions4: {
        chart: {
          type: 'bar',
          height: 430
        },
        colors: ['#008000', '#FF0000'],
        plotOptions: {
          bar: {
            vertical: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          shared: true,
          intersect: false
        },
        xaxis: {
          labels: {
            hideOverlappingLabels: false,
            trim: true,
          }
        },
      },
      series4: [{
        name: ' ',
        data: []
      }, {
        name: '',
        data: []
      }],


    };
  },
  created() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    if (this.$cookies.isKey("login_authentication")) {
            let encryptedText = this.$cookies.get("login_authentication");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/amazonrepricer/dashboard/");
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication1")) {
            let encryptedText = this.$cookies.get("login_authentication1");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }
        else if (this.$cookies.isKey("login_authentication2")) {
            let encryptedText = this.$cookies.get("login_authentication2");
            const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
            //console.log("decrypt: ", decryptedText);
            if (decryptedText == "authenticated") {
                this.$q.loading.hide();
                this.$store.dispatch("setPathName", "/amazonrepricer/dashboard/");
            }
            else {
                this.$q.loading.hide();
                this.$router.push({
                    name: "NotAuthenticated",
                });
                return;
            }
        }else {
      this.$q.loading.hide();
      this.$router.push({
        name: "NotAuthenticated",
      });
      return;
    }

  },
  mounted() {
    this.$q.loading.show({
            message: "Loading..",
        });
    var productsURL = this.api_url + "/dashboard/get_inventory_dashboard_data/" + this.$org_id.label;
    this.$http
      .get(productsURL)
      .then((response) => {
        if(response.data == null){
          this.dataUnavailable == true;
          this.$q.loading.hide();
          return
        }
        var result = response.data[0]
        this.line = response.data[0]
        var data1 = result.map((item) =>
          item.productName
        );
        data1 = [...new Set(data1)]
        this.area = response.data[2];
        this.setGraph(data1[0])
        this.products = data1
        this.campaignName = data1[0]
        this.campaignName1 = data1[0].slice(0,75)
        for (var j = 0; j < data1.length; j++) {
          var products = result.filter((items) => {
            return items.productName == data1[j];
          })
          var productCount = products.map((item) =>
            item.orderItemCount
          );
          var sum = 0;
          for (var i = 0; i < productCount.length; i++) {
            sum = sum + parseFloat(productCount[i])
          }
          this.array.push(sum)
        }
        const sortedNumbers = this.array.sort((a, b) => b - a);
      
      // slice the largest 5 numbers and add them to the largestNumbers array
      this.array = sortedNumbers.slice(0, 5);
        this.series2 = this.array,
          this.chartOptions2 = {
            chart: {
              type: 'pie',
            },
            labels: this.products.slice(0, 5),
            responsive: [{
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
          }
        //bar
        var result2 = response.data[1]
        var data2 = result2.map((item) =>
          item.productName
        );
        data2 = [...new Set(data2)]
        var actual = result2.map((item) =>
          item.Actual
        );
        var predicted = result2.map((item) =>
          item.Predicted
        );
        this.actual = actual;
        this.predicted = predicted;
        this.chartOptions4 = {
          chart: {
            type: 'bar',
            height: 430,
            width:1000
          },
          colors: ['#DF362D','#0E86D4',],
          plotOptions: {
            bar: {
              vertical: true,
              dataLabels: {
                position: 'top',
              },
            }
          },
          dataLabels: {
            enabled: false,
            offsetX: -6,
            style: {
              fontSize: '12px',
              colors: ['#fff']
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
          },
          tooltip: {
            shared: true,
            intersect: false
          },
          xaxis: {
            categories: data2,
            labels: {
              hideOverlappingLabels: false,
              trim: true,
            }
          },
        },
          this.series4 = [{
            name: 'Forecasted sales',
            data: this.predicted
          },
          {
            name: 'Actual sales ',
            data: this.actual
          }]
          this.$q.loading.hide();
      }).catch(() => {
        this.$router.push("/home/" + this.$org_encryprt.label);
      });
  },
  methods: {
    setGraph(item) {
    this.campaignName = item
      this.campaignName1 = item.slice(0,75);
      //line
      var products = this.line.filter((items) => {
        return items.productName == this.campaignName;
      })
      var date = products.map((item) =>
        (item.date).slice(0, 10)
      );
      var QuantitySold = products.map((item) =>
        item.QuantitySold
      );
      this.series1 = [{
        name: 'QuantitySold',
        data: QuantitySold
      }]
      this.date = date;
      this.chartOptions1 = {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        xaxis: {
          categories: this.date,
        }
      }
      //  
      //area

      var products = this.area.filter((items) => {
        return items.productName == this.campaignName;
      })
      var date = products.map((item) =>
        (item.ds).slice(0, 10)
      );

      this.date = date;
      var str = products.map((item) =>
        (item.STR).toFixed(2)
      );
      this.series3 = [{
        name: "Sell Through Rate",
        data: str
      }]
      this.chartOptions3 = {
        chart: {
          type: 'area',
          height: 350,
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        labels: this.date,

        yaxis: {
          opposite: false
        },
        legend: {
          horizontalAlign: 'left'
        }
      }
      //
    }
  }

};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.apexcharts-toolbar {
    position: absolute;
    z-index: 11;
    max-width: 176px;
    text-align: right;
    border-radius: 3px;
    padding: 0 6px 2px;
    display: none !important;
    justify-content: space-between;
    align-items: center;
}
body {
    font-family: "Montserrat", sans-serif !important;
}
.apexcharts-menu-icon{
    display: none !important;
}
.apexcharts-canvas{
    display: none !important;
}
.apexcharts-selection-icon {
    display: none;
}

.graph {
  border-radius: 10px;
  margin-right: 10px;
  text-align: center;
  background-color: white;
  box-shadow: 0px 3px 6px #9BDDD3;
  margin-left: 1px
}

.graph h5 {
  margin-top: 5px;
  color: #102689;
  font-weight: bold;
}
.barchart{
    overflow-x : scroll;
}

</style>